/***
 * 创建人：李珊
 * 时间：2023-1-31
 * 描述: 素材管理-知识提取
 * 使用说明:
 * 更新说明:
 */
import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { ActivatedRoute } from '@angular/router';
import { KmsService } from '../../../kms.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { ImgViewComponent } from '../../../components/img-view/img-view.component';
import { ocrTextConfigBoxComponent } from '../ocr-text-config-box/ocr-text-config-box.component';
import { OcrTextConfigCompareViewComponent } from '../ocr-text-config-compare-view/ocr-text-config-compare-view.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';

declare var $;

@Component({
    selector: 'app-knowledge-extract',
    templateUrl: './knowledge-extract.component.html',
    styleUrls: ['./knowledge-extract.component.css']
})
export class KnowledgeExtractComponent implements OnInit {
    @ViewChild('imgView') imgView: ImgViewComponent | undefined;//获取子组件对象
    // 重命名弹框
    @ViewChild('addZiModal') addZiModal: SwModalframeComponent;
    //确认删除弹框
    @ViewChild("trim") trim: SwMassageConfirmComponent;
    ids: any;
    // 路由参数
    params: any = {};
    // 源文件及文字预览方式  0:同时查看源文件和文字；1：只看源文件；2：只看文字；
    viewOptions: any = ['同时查看源文件和文字', '只看源文件', '只看文字'];
    viewIndex = 0;
    percent = 50;
    showViewOptions = false;
    isFileView = false;  // 是否支持预览源文件
    showImgList = false; // 是否展示左侧缩略图列表
    // 当前正在操作的模块：catalogue ：目录；img:图像；table:表格；text:文字；
    selected: string = ''
    // 素材信息
    resourceInfo: any = {
        materialCategory: 'FILE_TYPE_PICTURE'
    };
    // 排版格式 1. 横排   2.竖排  2.其他
    docType: any = '';
    // 素材内容数据
    contentList: any = [];
    showList: any = [];
    // 素材文本内容分页参数
    pageBase: any = {
        current: 1,
        size: 1,
        pages: 1,
        total: 1
    };
    // 当前正在预览的某一页的数据：页码、文件路径、文字等信息
    currentData: any = {}
    // 当前正在预览的某一页的图片
    resourcePath: any;
    // 文本查看模式 0: 文本模式；1：坐标模式；
    textViewMode = 0;
    // 是否正在编辑文本内容
    isEditing: boolean = false;
    // 当前正在编辑的某页内容的id
    detailId: string = '';
    /**
     * 如果是图片，就创建图片预览对象
     * @ignore
     */
    gallery: any
    isLoading: boolean = true;
    // 通过框选添加的字信息
    ziObj: any = {};
    //是否要等比缩放
    isScale: boolean = true;
    //图片原图信息：宽度，高度 ==>用于计算解析后的高度，和坐标比例系数
    imgWidth: number = null;
    imgHeight: number = null;
    //文字图片解析后的高度  ==> 宽度 400px是固定的，高度根据原图的宽高比例确定 ==>wordBoxHeight/740 == imgHeight/imgWidth ==>wordBoxHeight/imgHeight == 740/imgWidth
    wordBoxWidth: number = 740 // 以电脑显示器 1920*1280 标准计算的最佳宽度 ===》所以值 740固定
    wordBoxHeight: number = null
    //坐标等比缩小或扩大的系数
    scale: number = 1;
    //容器缩放比例
    containerScale: number = 1;
    //ocr识别后的字体坐标
    initOcrStringDatas:string = '';
    //正文+注释数据
    ocrTextList: any = []; 
    //页眉数据
    ocrHeaderList: any = [];
    //页脚数据
    ocrFooterList: any = [];
    //中缝数据
    middleSeamList: any = [];
    //其他数据
    otherList: any = [];
    //版面分析数据
    layoutStr:string = '';
    // 新增的字
    addWords:any = [];
    typeOptions:any = [
        {id:'text',text:'正文'},
        {id:'note',text:'注释'},
        {id:'header',text:'页眉'},
        {id:'footer',text:'页脚'},
        {id:'middleSeam',text:'中缝'}
    ];
    operationTypeOptions:any = [
        {id:'font',text:'添加字'},
        {id:'area',text:'添加区域'}
    ];
    // 导航栏索引 0:基本处理  1:知识抽取
    navIndex = 0;
    constructor(
        private injector: Injector,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private jwt: SwJwtService,
        private box: SwMassageBoxService,
        private mask: SwMaskService,
        private sanitizer: DomSanitizer,
        private create: SwCreateModalComponentService,
        private activatedRouter: ActivatedRoute,
        private kmsService: KmsService,
        private instanceModuleService: InstanceModuleService
    ) {
        this.ids = "octtext" + Math.random().toString().split(".")[1];
        this.activatedRouter.queryParams.subscribe((param) => {
            this.params = JSON.parse(param.selectData);
            // 查询数据资源基本信息
            this.getResourceInfo();
            // 判断是否包含查询关键字
            if (this.params['keyword']) {
                setTimeout(() => {
                    // 默认展开左侧的搜索模块
                    this.select('text');
                }, 0);
            }
        });
    }

    ngOnInit() {
    }

    // 查询素材信息
    getResourceInfo() {
        let materialId = this.params.materialId;
        // 查询素材信息及著录信息
        this.kmsService.queryMaterialById(materialId).subscribe(
            data => {
                if (data.code == '200') {
                    let res = data.data;
                    // 获取素材基本信息
                    this.resourceInfo = res;
                    if(this.resourceInfo.fileSuffix){
                        this.resourceInfo.fileSuffix = this.resourceInfo.fileSuffix && this.resourceInfo.fileSuffix.toLowerCase();
                    }
                    this.docType = res.docType;
                    // 文件预览(暂时支持pdf、txt、图像进行预览)
                    if (res.materialCategory === 'FILE_TYPE_DOCUMENT') {
                        if (this.resourceInfo.fileSuffix == 'pdf') {
                            this.isFileView = true;
                            this.showImgList = true;
                        }
                    } else if (res.materialCategory === 'FILE_TYPE_PICTURE') {
                        this.isFileView = true;
                    }
                    if (!this.isFileView) {
                        this.viewIndex = 2;
                    }
                    if (this.viewIndex == 0) {
                        this.percent = 50;
                    }
                    if (this.viewIndex == 1) {
                        this.percent = 0;
                    }
                    if (this.viewIndex == 2) {
                        this.percent = 100;
                    }
                } else {
                    this.box.waring('素材信息查询失败！');
                }
            }
        );
        // 查询素材图片信息
        this.kmsService.findByMaterialId(materialId).subscribe(
            data => {
                if (data.code == '200') {
                    this.isLoading = false;
                    this.contentList = data.data ? data.data : [];
                    if (this.contentList.length > 0) {
                        this.contentList = this.contentList.sort(function (a, b) { return a.pagesNum - b.pagesNum });
                        this.contentList.forEach(element => {
                            if(element.filePath){
                                element['src'] = environment.staticFileUrl + this.getThumbnailImg(element.filePath);
                            }else{
                                element['src'] = '';
                            }
                        });
                    }
                    // 获取分页
                    this.pageBase = {
                        current: this.params.current ? this.params.current : 1,
                        size: 1,
                        pages: this.contentList.length,
                        total: this.contentList.length
                    }
                    this.showList = this.contentList.slice(0, 10);
                    this.showCurrentPage(true);
                } else {
                    this.box.waring('素材内容信息查询失败！');
                }
            }
        );
    }

    // 根据素材每页原图获取缩略图
    getThumbnailImg(path) {
        if (path) {
            let arr = path.split('/');
            let str = '';
            for (let i = 0; i < arr.length; i++) {
                if (i == arr.length - 1) {
                    let arr1 = arr[i].split('.');
                    str += ('THUMB/' + arr1[0] + '_300@x.' + arr1[1]);
                } else {
                    str += arr[i] + '/';
                }
            }
            return str;
        } else {
            return '';
        }
    }

    // 切换上一页或下一页
    togglePage(state) {
        if (state == 'prev') {
            if (this.pageBase.current <= 1) {
                return;
            } else {
                this.pageBase.current--;
            }
        } else {
            if (this.pageBase.current >= this.pageBase.total) {
                return;
            } else {
                this.pageBase.current++;
            }
        }
        this.showCurrentPage();
    }

    // 搜索关键字高亮
    keywordSearch(event) {
        this.params.keyword = event.keyword;
        this.showCurrentPage();
    }

    // 点击缩略图
    selectFromThumbnailImg(item) {
        this.pageBase.current = item.pagesNum;
        this.showCurrentPage();
    }

    // 显示某一页的数据
    showCurrentPage(isInit?) {
        let current = this.pageBase.current;
        let detailId = this.contentList[current - 1].detailId;
        // 根据详情id查询某一页的数据
        this.kmsService.queryByDetailId({
            "detailId": detailId,
            "materialId": this.resourceInfo.materialId
        }).subscribe(
            data => {
                if (data.code == '200') {
                    this.currentData = data.data;
                    this.currentData.html = this.transformHTML(this.currentData);
                    this.resourcePath = this.currentData.filePath;
                    // this.resourcePath = 'swhtzstp/20230808/02/31c86c4afb63d2e449a1d138961b10d2/2.png';
                    // this.resourcePath = 'swhtzstp/20230808/02/31c86c4afb63d2e449a1d138961b10d2/1.jpg';
                    if (this.showImgList) {
                        if(current > this.showList.length){
                            this.showList = this.contentList.slice(0,Math.ceil(current / 10) * 10);
                        }
                        // let imgItemHeight = $('.thumbnailImgs .imgItem').eq(0).height();
                        // let top = 0;
                        // if (current > 2) {
                        //     top = imgItemHeight * (current - 2);
                        // }
                        // $('.thumbnailImgs').animate({ scrollTop: top }, 800);

                        // 获取对应iddom
                        const tabsId = document.getElementById('img-'+detailId);
                        // 判断进行平滑滚动
                        if (tabsId) {
                            tabsId.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }
                    }
                    // 文本类型为古籍时，才需要加载坐标模式下的数据
                    if (this.docType === "2") {
                        this.loadPositonMode(data.data);
                    }
                } else {
                    this.box.waring('素材内容信息查询失败！');
                }
            }
        );
    }

    // 转化html文本，使行内样式不被去掉
    transformHTML(data) {
        let html = '';
        if (data && data.materialText) {
            if (this.params.keyword) {
                let keyword = this.params.keyword;
                let str = data.materialText.replace(new RegExp(keyword, 'g'), '<i class="gaoliang">' + keyword + '</i>');
                html = str;
            } else {
                html = data.materialText;
            }
        } else {
            return '';
        }
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    // 获取页面内容复制的文本信息
    getSelectedTextStr() {
        let text = window.getSelection ? window.getSelection().toString() : '';
        if (!text) {
            return;
        }
        let data = {
            "materialId": this.resourceInfo.materialId,
            "sourceText": text.replace(new RegExp('\n', 'g'), ''),
            "sourceMaterial": this.resourceInfo.materialTitle,
            "pageNum": this.currentData.pagesNum,
            "relPageNum": this.currentData.relPageNum,
            "datasource": ''
        }
        this.jwt.setToKen('materialTextSelect', JSON.stringify(data));
    }

    // 设置源文件及文本预览方式
    setViewStyle(i) {
        if (this.viewIndex === i) {
            return;
        }
        // 不支持预览的文件类型不能进行 '同时查看源文件和文字','只看源文件'操作；
        if (!this.isFileView && i < 2) {
            return;
        }
        this.viewIndex = i;
        this.showViewOptions = false;
        if (this.viewIndex == 0) {
            this.percent = 50;
        }
        if (this.viewIndex == 1) {
            this.percent = 0;
        }
        if (this.viewIndex == 2) {
            this.percent = 100;
        }
        setTimeout(() => {
            this.gallery.resize();
        }, 150);
    }

    // 设置预览选项显示或隐藏
    toggleOptions(state) {
        this.showViewOptions = state;
    }

    // 左侧弹框，切换查看不同的模块
    select(state) {
        this.selected = state;
        $('.leftPart').css('left', '14px');
    }

    // 关闭左侧弹框
    clickHideLeft() {
        $('.leftPart').css('left', '-346px');
    }

    // 跳转到指定页
    toPage(event) {
        if (event == this.pageBase.current) {
            return;
        } else {
            this.pageBase.current = event;
            this.showCurrentPage();
        }
    }

    // 双击文本内容进入编辑页面
    showEditModule() {
        this.isEditing = true;
        this.detailId = this.currentData.detailId;
    }

    // 修改文本内容
    saveEditClick(event) {
        this.isEditing = false;
        this.detailId = '';
        this.showCurrentPage();
    }

    // 取消编辑文本内容
    cancleEditClick(event) {
        this.isEditing = false;
        this.detailId = '';
    }

    // 通过框选添加文字、区域；修改区域
    ziOrAreaOperate(event) {
        const rect = event.rect;
        const format = this.instanceModuleService.getImgFormat(event.bigImgUrl);
        this.ziObj = {
            imgUrl: event.bigImgUrl + rect.x + ',' + rect.y + ',' + rect.width + ',' + rect.height + '/full/0/default.' + format,
            points: {
                left: rect.x,
                top: rect.y,
                right: rect.x + rect.width,
                bottom: rect.y + rect.height,
            },
            str: '',
            type: rect.type ? rect.type : '',
            operationState: event.operationState,
            operationType: event.operationType ? event.operationType : 'font',
            index: event.operationState == 'add' ? -1 : event.index
        }
        this.addZiModal.toggle();
    }

    // 确认添加字
    sureAdd() {
        this.addZiModal.toggle();
        // 添加字
        if(this.ziObj.operationType == 'font'){
            this.imgView.clearEles();
            let item = {
                "word": this.ziObj.str,
                "confidence": 1,
                "points": this.ziObj.points
            }
            this.addWords.push(item);
        }else{
            // 添加区域
            if(this.ziObj.operationState == 'add'){
                this.imgView.clearEles();
                let layout_res = JSON.parse(this.layoutStr);
                const p = this.ziObj.points;
                layout_res.push({
                    "type": this.ziObj.type,
                    "bbox": [p.left, p.top, p.right, p.bottom]
                })
                console.log({
                    "type": this.ziObj.type,
                    "bbox": [p.left, p.top, p.right, p.bottom]
                })
                this.layoutStr = JSON.stringify(layout_res);
            }
            // 编辑区域
            else{
                let layout_res = JSON.parse(this.layoutStr);
                layout_res[this.ziObj.index].type = this.ziObj.type;
                const p = this.ziObj.points;
                layout_res[this.ziObj.index].bbox = [p.left, p.top, p.right, p.bottom];
                this.layoutStr = JSON.stringify(layout_res);
            }
        }
        this.updateMaterialContent();
    }

    // 删除区域
    deleteArea(){
        this.addZiModal.toggle();
        let layout_res = JSON.parse(this.layoutStr);
        layout_res.splice(this.ziObj.index,1);
        this.layoutStr = JSON.stringify(layout_res);
        this.updateMaterialContent();
    }

    // 新增、修改、删除字后，进行保存操作
    updateMaterialContent(){
        let ocrJson = JSON.parse(this.initOcrStringDatas);
        ocrJson.ocr_res.header = this.ocrHeaderList;
        ocrJson.ocr_res.content = this.ocrTextList;
        ocrJson.ocr_res.footer = this.ocrFooterList;
        ocrJson.ocr_res.middleSeam = this.middleSeamList;
        ocrJson.ocr_res.others = this.otherList.length>0 ? this.otherList[0].words : [];
        ocrJson.ocr_res.addWords = this.addWords;
        ocrJson.layout_res = JSON.parse(this.layoutStr);
        let jsonStr = JSON.stringify(ocrJson);
        // 新增、修改、删除字后,重新获取排好顺序的json对象
        this.kmsService.ocrSort({'orcjson': jsonStr}).subscribe(
            data => {
                if(data.code == '200'){
                    const res = data.data;
                    // 拼接参数
                    let params = JSON.parse(JSON.stringify(this.currentData));
                    // 获取添加字之后的带坐标的文本字段值
                    params.ocrJson = JSON.stringify(res);
                    params.materialText = res.text.fullText;
                    // 更新素材内容
                    this.kmsService.updateMaterialDetail(params).subscribe(
                        result => {
                            if (result.code == '200') {
                                this.box.success('操作成功！');
                                this.currentData.materialText = res.text.fullText;
                                this.currentData.ocrJson = params.ocrJson;
                                this.currentData.html = this.transformHTML(this.currentData);
                                this.loadPositonMode(params);
                            } else {
                                this.box.waring('操作失败！');
                            }
                        }
                    );
                }
            }
        )
    }

    // 取消添加字
    cancelAdd() {
        this.addZiModal.toggle();
        this.imgView.clearEles();
    }

    // 设置宽度百分比
    setPercent(state) {
        if (state == 'add') {
            if (this.percent < 100) {
                this.percent += 10;
            }
        } else {
            if (this.percent > 10) {
                this.percent -= 10;
            }
        }
    }

    loadPositonMode(element) {
        if (!element.ocrJson) {
            return;
        }
        const ocrDatas = JSON.parse(element.ocrJson);
        this.initOcrStringDatas = element.ocrJson;
        this.layoutStr = JSON.stringify(ocrDatas.layout_res);
        // 获取识别图片的原始宽高信息
        this.imgWidth = ocrDatas.imginfo.width;
        this.imgHeight = ocrDatas.imginfo.height;
        if (this.wordBoxWidth / this.imgWidth < 1) {
            this.scale = parseFloat((this.wordBoxWidth / this.imgWidth).toFixed(2));
        } else {
            this.scale = 1
        }
        //获取ocr识别的文字坐标信息数组
        this.fetchOcrData(ocrDatas.ocr_res)
    }

    fetchOcrData(ocrJson) {
        this.addWords = [];
        this.ocrTextList = [];
        this.ocrHeaderList = [];
        this.ocrFooterList = [];
        this.middleSeamList = [];
        this.otherList = [];
        const ocrParams = this.getDataByType(ocrJson);
        // 将字排列时距离顶部30
        let offset = 0;
        if (ocrParams.minTop > 30) {
            offset = ocrParams.minTop - 30;
            // 判断是否有正文
            if(ocrParams.hasText){
                this.ocrTextList.forEach(el => {
                    el.words.forEach(element => {
                        element.params.top = element.params.top - offset;
                    });
                });
            }
            // 判断是否有注释
            if(ocrParams.hasNote){
            }
            // 判断是否有页眉
            if(ocrJson.header.length>0){
                this.ocrHeaderList.forEach(el => {
                    el.words.forEach(element => {
                        element.params.top = element.params.top - offset;
                    });
                });
            }
            // 判断是否有页脚
            if(ocrJson.footer.length>0){
                this.ocrFooterList.forEach(el => {
                    el.words.forEach(element => {
                        element.params.top = element.params.top - offset;
                    });
                });
            }
            // 判断是否有中缝
            if(ocrJson.middleSeam.length>0){
                this.middleSeamList.forEach(el => {
                    el.words.forEach(element => {
                        element.params.top = element.params.top - offset;
                    });
                });
            }
            // 判断是否有其他数据
            if(ocrJson.others.length>0){
                this.otherList.forEach(el => {
                    el.words.forEach(element => {
                        element.params.top = element.params.top - offset;
                    });
                });
            }
        }
        // 将字排列时距离底部
        this.wordBoxHeight = ocrParams.maxTop - offset + 80;
        console.log(this.otherList)
    }

    // 分别处理正文、注释、页眉、页脚
    getDataByType(ocrJson){
        let hasText = false,hasNote= false;
        let minTop = 99999, maxTop = 0;
        Object.keys(ocrJson).forEach(key => {
            if(ocrJson[key].length>0){
                let textData = key == 'others' ? [{words:ocrJson[key]}] : ocrJson[key];
                // 遍历每一列
                textData.forEach((colomn,index1) => {
                    if(colomn.words){
                        // 遍历每一列下的每个字
                        colomn.words.forEach((word,index2) => {
                            if(word.type == 'text'){
                                hasText = true;
                            }
                            if(word.type == 'note'){
                                hasNote = true;
                            }
                            // 根据confidence设置文字样式
                            const c = word.confidence;
                            if(!c || c<=0.5){
                                word['class']='red';
                            }else if(c<=0.7){
                                word['class']='yellow';
                            }else{
                                word['class']='';
                            }

                            // 获取页面展示所需的参数
                            const params  = this.getShowParams(word);
                            word.params = params;
                            // 计算top的最大值及最小值
                            const top = params.top;
                            if(top>maxTop){
                                maxTop = top;
                            }
                            if(top<minTop){
                                minTop = top;
                            }
                        });
                    }
                });
                if(key == 'header'){
                    this.ocrHeaderList = textData;
                }
                if(key == 'footer'){
                    this.ocrFooterList = textData;
                }
                if(key == 'middleSeam'){
                    this.middleSeamList = textData;
                }
                if(key == 'others'){
                    this.otherList = textData;
                }
                if(key == 'content'){
                    this.ocrTextList = textData;
                }
            }
        });
        return {
            hasText: hasText,
            hasNote: hasNote,
            minTop: minTop,
            maxTop: maxTop,
        }
    }

    // 根据字的坐标获取页面展示时的实际坐标及宽高
    getShowParams(word){
        let points = word.points;
        let leftTop = [points.left,points.top]
        let rightTop = [points.right,points.top]
        let rightBottom = [points.right,points.bottom]
        let leftBottom = [points.left,points.bottom]
        //乘上比例系数
        let leftTopScalse;
        let rightTopScalse;
        let rightBottomScalse;
        let leftBottomScalse;
        if (this.isScale) {
            //乘上比例系数 scale
            leftTopScalse = [(leftTop[0] * this.scale).toFixed(2), (leftTop[1] * this.scale).toFixed(2)];
            rightTopScalse = [(rightTop[0] * this.scale).toFixed(2), (rightTop[1] * this.scale).toFixed(2)];
            rightBottomScalse = [(rightBottom[0] * this.scale).toFixed(2), (rightBottom[1] * this.scale).toFixed(2)];
            leftBottomScalse = [(leftBottom[0] * this.scale).toFixed(2), (leftBottom[1] * this.scale).toFixed(2)];
        } else {
            //暂不乘上比例系数
            leftTopScalse = leftTop;
            rightTopScalse = rightTop;
            rightBottomScalse = rightBottom;
            leftBottomScalse = leftBottom;
        };
        //数据结构处理
        let wid = Number.parseFloat(rightTopScalse[0]) - Number.parseFloat(leftTopScalse[0])
        let higt = Number.parseFloat(leftBottomScalse[1]) - Number.parseFloat(leftTopScalse[1])
        //字体的大小
        // let fontSize = Math.floor(wid / 2)
        let fontSize = word.fontSize*(this.scale === 1 ?  0.7 : this.scale);
        return {
            left: Number.parseFloat(leftTopScalse[0]),
            top: Number.parseFloat(leftTopScalse[1]),
            right: Number.parseFloat(rightTopScalse[0]),
            width: wid,
            height: higt,
            fontSize: fontSize
        };
    }

    // 文字纠正区域
    dropdown: boolean = false
    /**
     *  @ignore
     *  展现关闭下拉
     */
    swSelectMultiComponentRef: any;
    
    // 打开文字纠正弹框
    open(event, list, eleId, index1, index2) {
        event.stopPropagation()
        if ($('ocrtextconfigboxcomponent')) {
            $('body').find('ocrtextconfigboxcomponent').remove();
        }
        let isNeedJudgeCol = false
        let type = 2
        let title = '文字纠正';
        if (!isNeedJudgeCol) {
            const com = document.createElement(ocrTextConfigBoxComponent.name);
            //创建动态组件
            const factory = this.componentFactoryResolver.resolveComponentFactory(ocrTextConfigBoxComponent);
            this.swSelectMultiComponentRef = factory.create(this.injector, [], com);
            this.applicationRef.attachView(this.swSelectMultiComponentRef.hostView);
            // 打开下拉框
            this.dropdown = true;
            // 向动态创建的组件传递参数
            this.swSelectMultiComponentRef.instance["ids"] = this.ids;
            // 向动态创建的组件传递参数
            this.swSelectMultiComponentRef.instance["title"] = title;
            // 向动态创建的组件传递参数
            this.swSelectMultiComponentRef.instance["elemId"] = eleId;
            // 向动态创建的组件传递参数
            this.swSelectMultiComponentRef.instance["selectedValue"] = list;

            this.swSelectMultiComponentRef.instance["type"] = type;

            this.swSelectMultiComponentRef.instance["index"] = index1;

            this.swSelectMultiComponentRef.instance["index2"] = index2;

            this.swSelectMultiComponentRef.instance["configHeight"] = '150px';
            // 向动态创建的组件传递回调函数
            this.swSelectMultiComponentRef.instance["closeSelect"].subscribe(data => {
                try {
                    this.dropdown = false
                    // 失去焦点
                    // this.input.nativeElement.blur()
                    // 移除元素
                    document.body.removeChild(com);
                    this.applicationRef.detachView(this.swSelectMultiComponentRef.hostView);
                    // 销毁组件
                    this.swSelectMultiComponentRef.destroy()
                } catch (e) { }

            });

            this.swSelectMultiComponentRef.instance["changeClick"].subscribe(data => {
                try {
                    // 有参数就触发此事件 抛出选择的参数对象
                    this.updateConfig(data)
                } catch (e) { }

            });
            // 将组件加到dom中去显示
            document.body.appendChild(com);
        }
    }

    //更新对应数组的参数值 ==>以后扩展框选功能时，要修改
    updateConfig(config) {
        // 编辑字
        if (config.type == 'edit') {
            if(config.textType == 'header'){
                this.ocrHeaderList[config.index].words[config.index2]['word'] =  config.value;
                this.ocrHeaderList[config.index].words[config.index2]['confidence'] =  1;
            }else if(config.textType == 'footer'){
                this.ocrFooterList[config.index].words[config.index2]['word'] =  config.value;
                this.ocrFooterList[config.index].words[config.index2]['confidence'] =  1;
            }else if(config.textType == 'middleSeam'){
                this.middleSeamList[config.index].words[config.index2]['word'] =  config.value;
                this.middleSeamList[config.index].words[config.index2]['confidence'] =  1;
            }else if(config.textType == 'text' || config.textType == 'note'){
                this.ocrTextList[config.index].words[config.index2]['word'] =  config.value;
                this.ocrTextList[config.index].words[config.index2]['confidence'] =  1;
            }else{
                this.otherList[config.index].words[config.index2]['word'] =  config.value;
                this.otherList[config.index].words[config.index2]['confidence'] =  1;
            }
        } 
        // 删除字
        else if (config.type == 'delete') {
            if(config.textType == 'header'){
                this.ocrHeaderList[config.index].words.splice(config.index2, 1);
            }else if(config.textType == 'footer'){
                this.ocrFooterList[config.index].words.splice(config.index2, 1);
            } if(config.textType == 'middleSeam'){
                this.middleSeamList[config.index].words.splice(config.index2, 1);
            } if(config.textType == 'other'){
                this.otherList[config.index].words.splice(config.index2, 1);
            }else {
                this.ocrTextList[config.index].words.splice(config.index2, 1);
            }
        }
        this.updateMaterialContent();
        this.close()
    }

    /**
     * 关闭下拉框
     * @ignore
     */
    close() {
        // this.dropdown = false;
        this.swSelectMultiComponentRef.instance.close()
    }

    //鼠标移入事件
    mouseoverEvent(ocrWord) {
        let rect = {
            x: ocrWord.points.left,
            y: ocrWord.points.top,
            width: ocrWord.width,
            height: ocrWord.height
        }
        this.imgView.addLayer(rect);
    }

    //鼠标移出事件
    mouseoutEvent() {
        this.imgView.clearEles();
    }

    //点击查看ocr已识别的信息和对应列图片
    clickViewOcrCompareText() {
        let viewData = JSON.parse(JSON.stringify(this.currentData));
        let bigImgUrl = this.getIiifImgUrl();
        let param = { "view": "view", "viewData": viewData, "bigImgUrl": bigImgUrl }
        this.create.createModal(OcrTextConfigCompareViewComponent, param, this.updateCallback2.bind(this))
    }

    updateCallback2(){
        // 根据详情id查询某一页的数据
        this.kmsService.queryByDetailId({
            "detailId": this.currentData.detailId,
            "materialId": this.resourceInfo.materialId
        }).subscribe(
            data => {
                if (data.code == '200') {
                    this.currentData = data.data;
                    this.currentData.html = this.transformHTML(this.currentData);
                    this.loadPositonMode(data.data);
                } else {
                    this.box.waring('素材内容信息查询失败！');
                }
            }
        );
    }

    //拼接大图展示地址
    getIiifImgUrl(){
        const url = this.resourcePath;
        const pathArr = url.split('/');
        let res = environment.iiifImgUrl;
        for(let i=0;i<pathArr.length;i++){
        res += (i == pathArr.length -1 ? pathArr[i] + '/' : pathArr[i]+'%2F');
        }
        return res;
    }

    onMouseWheel(ev) {
        var ev = ev || window.event;
        var down = true; // 定义一个标志，当滚轮向下滚时，执行一些操作
        down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0;
        if (down) {
            // 缩小
            if(this.containerScale > 1){
                this.containerScale = this.containerScale - 0.1;
                const w = $('#textViewContainer').width();
                const x = this.containerScale == 1 ? 0 : w*0.25;
                $('#textViewContainer').css('transform','scale('+this.containerScale+') translateX('+x+'px)');
            }
        } else {
            // 放大
            if(this.containerScale < 2){
                this.containerScale = this.containerScale + 0.1;
                const w = $('#textViewContainer').width();
                const x = this.containerScale == 1 ? 0 : w*0.25;
                $('#textViewContainer').css('transform','scale('+this.containerScale+') translateX('+x+'px)');
            }
        }
        if (ev.preventDefault) {/*FF 和 Chrome*/
            ev.preventDefault();// 阻止默认事件
        }
        return false;
    }

    // 点击选中导航
    navClick(i){
        this.navIndex = i;
    }

    // 监听左侧缩略图容器滚动事件，滚动到底部时获取下十页
    listenScroll(event) {
        // 元素的滚动高度
        const scrollHeight = event.srcElement.scrollHeight;
        // 元素的可视高度
        const clientHeight = event.srcElement.clientHeight;
        // 已滚动的距离
        const scrollTop = event.srcElement.scrollTop;
        // 计算是否到达底部（考虑设置的阈值）
        const isBottom = scrollTop + clientHeight >= scrollHeight - 10;
        if(isBottom){
            if (this.showImgList) {
                if(this.showList.length < this.contentList.length){
                    this.showList = this.contentList.slice(0,this.showList.length+10);
                }
            }
        }
    }
}
